"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isNil = _interopRequireDefault(require("../object/isNil"));

var _querystring = _interopRequireDefault(require("querystring"));

var appendQueryParams = function appendQueryParams(url, paramObject) {
  if ((0, _isNil["default"])(url)) return url;

  if (!paramObject) {
    return url;
  }

  var joinChar = url.indexOf('?') !== -1 ? '&' : '?';

  var query = _querystring["default"].stringify(paramObject);

  if (!query) {
    return url;
  }

  return "".concat(url).concat(joinChar).concat(query);
};

var _default = appendQueryParams;
exports["default"] = _default;